<template>
<div>
    <section>
        <div class="top-nav-div">
            <div class="top-nav-elements">
                <a href="#" class="link-block-42 w-inline-block">
                    <img :src="require('@/assets/images/NewSelf_Logo.png')" sizes="(max-width: 479px) 100vw, 84.03125px" loading="lazy" class="image-294">
                </a>
                <div class="form-nav-div">
                    <a href="#" @click.prevent="questionId > 1 ? questionId-- : null" class="back-link w-inline-block">
                        <div class="text-block-507">&lt;-</div>
                    </a>
                    <div class="form-progress-div">
                        <div>
                            <div class="text-block-508">Step <strong>{{ questionId-1 }}</strong> of <strong>{{ totalQuestions-1 }}</strong></div>
                        </div>
                        <div class="form-precent-div">
                            <div class="text-block-509"><strong>{{ Math.round(((questionId - 2) / (totalQuestions-1)) * 100) }}%</strong> Complete</div>
                        </div>
                    </div>
                </div>
                <div class="div-block-1442">
                    <div class="text-block-505"></div>
                </div>
            </div>
        </div>
    </section>

    <section class="section-7">
        <div class="questions-div">
            <!-- Personal Information -->
            <!-- Erection Problems -->
            <div class="question-container" v-if="questionId === 2">
                <div class="question-div-2">
                    <div class="text-block-513">Do you ever have a problem getting or maintaining an erection that is rigid enough for sex?</div>
                    <div class="felix-form-block w-form">
                        <a v-for="option in erectionProblemOptions" :key="option" href="#" @click.prevent="handleErectionProblem(option)" class="link-block-30 w-inline-block">
                            <div>
                                <div class="text-block-545">{{ option }}</div>
                            </div>
                            <div>
                                <div class="text-block-546">-></div>
                            </div>
                        </a>
                    </div>
                </div>
            </div>

            <!-- Morning Erections -->
            <div class="question-container" v-if="questionId === 3">
                <div class="question-div-2">
                    <div class="text-block-513">Do you get erections...</div>
                    <div class="felix-form-block w-form">
                        <form @submit.prevent="nextQuestion">
                            <a href="#" class="link-block-30 w-inline-block" v-for="option in erectionTimingOptions" :key="option" @click.prevent="setErections(option)">
                                <div>
                                <div class="text-block-545">{{option}}</div>
                                </div>
                                <div>
                                <div class="text-block-546">-></div>
                                </div>
                            </a>
                        </form>
                    </div>
                </div>
            </div>

            <!-- Previous ED Treatment -->
            <div class="question-container" v-if="questionId === 4">
                <div class="question-div-2">
                    <div class="text-block-513">Have you ever been formally treated for ED or tried any medicines, vitamins, or supplements to treat it?</div>
                    <div class="felix-form-block w-form">
                        <div class="div-block-1487">
                            <a href="#" @click.prevent="handlePreviousTreatment('Yes')" class="button-68 w-button">Yes</a>
                            <a href="#" @click.prevent="handlePreviousTreatment('No')" class="button-68 w-button">No</a>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Treatment Details -->
            <div class="question-container" v-if="questionId === 5 && formData.previousTreatment === 'Yes' && !showSideEffects" >
                <div class="question-div-2">
                    <div class="text-block-513">Please provide details about your previous ED treatments</div>
                    <div class="felix-form-block w-form">
                        <form @submit.prevent="showSideEffects= true">
                            <textarea v-model="formData.treatmentDetails" class="text-field-43 w-input" placeholder="Please describe treatments, dosages, and effectiveness..." required></textarea>
                            <input type="submit" class="form-button w-button" value="Next ->">
                        </form>
                    </div>
                </div>
            </div>

            <div class="question-container" v-if="questionId === 5 && showSideEffects">
                <div class="question-div-2">
                    <div class="text-block-513">Did you experience any side effects?</div>
                    <div class="felix-form-block w-form">
                        <form @submit.prevent="nextQuestion">
                            <div class="div-block-1487">
                                <a href="#" @click.prevent="handleSideEffects('No')" class="button-68 w-button">No</a>
                                <a href="#" @click.prevent="handleSideEffects('Yes')" class="button-68 w-button">Yes</a>
                            </div>
                            <textarea v-if="formData.hadSideEffects === 'Yes'" v-model="formData.sideEffectsDetails" class="text-field-43 w-input" placeholder="Please describe any side effects..." required></textarea>
                            <input type="submit" class="form-button w-button" value="Next ->">
                        </form>
                    </div>
                </div>
            </div>

            <!-- Physical Exam -->
            <div class="question-container" v-if="questionId === 6">
                <div class="question-div-2">
                    <div class="text-block-513">Have you had a physical exam with a healthcare provider in the past 5 years?</div>
                    <div class="felix-form-block w-form">
                            <a href="#" class="link-block-30 w-inline-block" v-for="option in physicalExamOptions" :key="option.value" @click.prevent="handlePhysicalExam(option)">
                                <div>
                                <div class="text-block-545">{{ option.label }}</div>
                                </div>
                                <div>
                                <div class="text-block-546">-&gt;</div>
                                </div>
                            </a>
                        <form v-if="formData.physicalExam?.requiresDetails" @submit.prevent="nextQuestion">
                            <textarea v-model="formData.physicalExamDetails" class="text-field-43 w-input" placeholder="Please explain any issues found during your physical exam..." required></textarea>
                            <input type="submit" class="form-button w-button" value="Next ->">
                        </form>
                    </div>
                </div>
            </div>

            <!-- Blood Pressure -->
            <div class="question-container" v-if="questionId === 7">
                <div class="question-div-2">
                    <div class="text-block-513">Was your blood pressure taken in the past year?</div>
                    <div class="felix-form-block w-form">
                        <a href="#" class="link-block-30 w-inline-block" @click.prevent="handleBloodPressure('Yes')">
                                <div>
                                <div class="text-block-545">Yes</div>
                                </div>
                                <div>
                                <div class="text-block-546">-&gt;</div>
                                </div>
                        </a>
                        <a href="#" class="link-block-30 w-inline-block" @click.prevent="handleBloodPressure('No')">
                                <div>
                                <div class="text-block-545">No</div>
                                </div>
                                <div>
                                <div class="text-block-546">-&gt;</div>
                                </div>
                        </a>
                        

                        <form v-if="formData.bloodPressureTaken === 'Yes'" @submit.prevent="nextQuestion">
                            <input v-model="formData.bloodPressureValue" class="text-field-43 w-input" style="width:100%" placeholder="Blood pressure value (e.g., 120/80)" required>
                            <input type="submit" class="form-button w-button" value="Next ->">
                        </form>
                    </div>
                </div>
            </div>

            <!-- Current Medications -->
            <div class="question-container" v-if="questionId === 8">
                <div class="question-div-2">
                    <div class="text-block-513">Do you take any medications, vitamins, or supplements regularly?</div>
                    <div class="felix-form-block w-form">
                        <div class="div-block-1487">
                            <a href="#" @click.prevent="handleMedications('Yes')" class="button-68 w-button">Yes</a>
                            <a href="#" @click.prevent="handleMedications('No')" class="button-68 w-button">No</a>
                        </div>

                        <form v-if="formData.takesMedications === 'Yes'" @submit.prevent="nextQuestion">
                            <textarea v-model="formData.medicationsList" class="text-field-43 w-input" placeholder="Please list medications with dosages..." required></textarea>
                            <input type="submit" class="form-button w-button" value="Next ->">
                        </form>
                    </div>
                </div>
            </div>

            <!-- Nitrate Medications -->
            <div class="question-container" v-if="questionId === 9">
                <div class="question-div-2">
                    <div class="text-block-513">Do you take any of the following medicines?</div>
                    <div class="felix-form-block w-form">
                        <form @submit.prevent="checkResponseSelected('nitrateMeds')">
                            <label class="w-checkbox checkbox-field-15 w-clearfix" v-for="med in nitrateOptions" :key="med">
                                    <input type="checkbox" :value="med" v-model="formData.nitrateMeds" class="w-checkbox-input checkbox-11">
                                    <span class="checkbox-label-12 w-form-label" for="checkbox-3">{{med}}</span>
                            </label>
                            <input type="submit" class="form-button w-button" value="Next ->">
                        </form>
                    </div>
                </div>
            </div>

            <!-- Allergies -->
            <div class="question-container" v-if="questionId === 10">
                <div class="question-div-2">
                    <div class="text-block-513">Do you have any allergies?</div>
                    <div class="felix-form-block w-form">
                        <div class="div-block-1487">
                            <a href="#" @click.prevent="handleAllergies('Yes')" class="button-68 w-button">Yes</a>
                            <a href="#" @click.prevent="handleAllergies('No')" class="button-68 w-button">No</a>
                        </div>

                        <form v-if="formData.hasAllergies === 'Yes'" @submit.prevent="nextQuestion">
                            <textarea v-model="formData.allergiesList" class="text-field-43 w-input" placeholder="Please list your allergies..." required></textarea>
                            <input type="submit" class="form-button w-button" value="Next ->">
                        </form>
                    </div>
                </div>
            </div>

            <!-- Medical Conditions -->
            <div class="question-container" v-if="questionId === 11">
                <div class="question-div-2">
                    <div class="text-block-513">Do you have any medical conditions or history of prior surgeries?</div>
                    <div class="felix-form-block w-form">
                        <div class="div-block-1487">
                            <a href="#" @click.prevent="handleMedicalConditions('Yes')" class="button-68 w-button">Yes</a>
                            <a href="#" @click.prevent="handleMedicalConditions('No')" class="button-68 w-button">No</a>
                        </div>

                        <form v-if="formData.hasMedicalConditions === 'Yes'" @submit.prevent="nextQuestion">
                            <textarea v-model="formData.medicalConditionsList" class="text-field-43 w-input" placeholder="Please list your medical conditions and prior surgeries..." required></textarea>
                            <input type="submit" class="form-button w-button" value="Next ->">
                        </form>
                    </div>
                </div>
            </div>
                <!-- Cardiovascular Risk Factors -->
                <div class="question-container" v-if="questionId === 12 && !showCardRisk">
                    <div class="question-div-2">
                        <div class="text-block-513">Do any of the following cardiovascular risk factors apply to you?</div>
                        <div class="felix-form-block w-form">
                            <form @submit.prevent="checkCardHealth">
                                    <label class="w-checkbox checkbox-field-15 w-clearfix" v-for="risk in cardiovascularRisks" :key="risk.label">
                                        <input type="checkbox" :value="risk.label" v-model="formData.cardioRisks" class="w-checkbox-input checkbox-11">
                                        <span class="checkbox-label-12 w-form-label" for="checkbox-3">{{risk.label}}</span>
                                    </label>
                                    
                                <input type="submit" class="form-button w-button" value="Next ->">
                            </form>
                        </div>
                    </div>
                </div>
                <div class="question-container" v-if="questionId === 12 && showCardRisk">
                    <div class="question-div-2">
                        <div class="felix-form-block w-form">
                            <form @submit.prevent="handleCardioRiskSubmit">
                                <div v-for="risk in selectedRisksWithDetails" :key="risk.label">
                                    <div class="text-block-513">{{ risk.detailPrompt }}</div>
                                    <textarea v-model="formData.riskDetails[risk.label]" class="text-field-43 w-input" :placeholder="risk.placeholder" required></textarea>
                                    <br/>
                                </div>
                                <input type="submit" class="form-button w-button" value="Next ->">
                            </form>
                        </div>
                    </div>
                </div>

                <!-- Medical Diagnoses -->
                <div class="question-container" v-if="questionId === 13 && !askConditions">
                    <div class="question-div-2">
                        <div class="text-block-513">Have you been diagnosed with any of the following conditions?</div>
                        <div class="felix-form-block w-form">
                            <form @submit.prevent="handleDiagnosesSubmit">
                                <label class="w-checkbox checkbox-field-15 w-clearfix" v-for="condition in medicalConditions" :key="condition">
                                    <input type="checkbox" :value="condition" v-model="formData.diagnoses" class="w-checkbox-input checkbox-11">
                                    <span class="checkbox-label-12 w-form-label" for="checkbox-3">{{condition}}</span>
                                </label>
                                <input type="submit" class="form-button w-button" value="Next ->">
                            </form>
                        </div>
                    </div>
                </div>

                <div class="question-container" v-if="questionId === 13 && askConditions">
                    <div class="question-div-2">
                        <div class="felix-form-block w-form">
                            <form @submit.prevent="handleSingleConditionSubmit">
                                <div v-if="currentCondition">
                                    <div class="text-block-513">Please tell us more about your {{ currentCondition }}:</div>
                                    <textarea 
                                        v-model="formData.diagnosisDetails[currentCondition]" 
                                        class="text-field-43 w-input" 
                                        placeholder="Describe your diagnosis and treatment..." 
                                        required
                                    ></textarea>
                                </div>
                                <input type="submit" class="form-button w-button" value="Next ->">
                            </form>
                        </div>
                    </div>
                </div>


                
                <!-- Cardiovascular Symptoms -->
                <div class="question-container" v-if="questionId === 14">
                    <div class="question-div-2">
                        <div class="text-block-513">Do you experience any of the following cardiovascular symptoms?</div>
                        <div class="felix-form-block w-form">
                            <form @submit.prevent="handleCardioSymptomsSubmit">

                                <label class="w-checkbox checkbox-field-15 w-clearfix" v-for="symptom in cardiovascularSymptoms" :key="symptom.label">
                                    <input type="checkbox" :value="symptom.label" v-model="formData.cardioSymptoms" class="w-checkbox-input checkbox-11">
                                    <span class="checkbox-label-12 w-form-label" for="checkbox-3">{{symptom.label}}</span>
                                </label>
                                <div v-if="needsLegCrampDetails">
                                    <div class="text-block-513">Please tell us more about your leg cramps:</div>
                                    <textarea v-model="formData.legCrampDetails" class="text-field-43 w-input" placeholder="Describe your leg cramps..." required></textarea>
                                </div>

                                <input type="submit" class="form-button w-button" value="Next ->">
                            </form>
                        </div>
                    </div>
                </div>

                <!-- Recreational Drugs -->
                <div class="question-container" v-if="questionId === 15 && !askDrugDetails">
                    <div class="question-div-2">
                        <div class="text-block-513">Do you use any of the following recreational drugs?</div>
                        <div class="form-subs">Severe reactions may result if ED meds are used in conjunction with recreational drugs.</div>
                        <div class="felix-form-block w-form">
                            <form @submit.prevent="handleDrugsSubmit">
                                <label class="w-checkbox checkbox-field-15 w-clearfix" v-for="drug in recreationalDrugs" :key="drug">
                                    <input type="checkbox" :value="drug" v-model="formData.drugs" class="w-checkbox-input checkbox-11">
                                    <span class="checkbox-label-12 w-form-label" for="checkbox-3">{{drug}}</span>
                                </label>
                                <input type="submit" class="form-button w-button" value="Next ->">
                            </form>
                        </div>
                    </div>
                </div>

                <div class="question-container" v-if="questionId === 15 && askDrugDetails">
                    <div class="question-div-2">
                        <div class="felix-form-block w-form">
                            <form @submit.prevent="handleSingleDrugSubmit">
                                <div v-if="currentDrug">
                                    <div class="text-block-513">Please explain your use of {{ currentDrug }}:</div>
                                    <textarea 
                                        v-model="formData.drugDetails[currentDrug]" 
                                        class="text-field-43 w-input" 
                                        placeholder="How frequently do you use this? When was the last time?" 
                                        required
                                    ></textarea>
                                </div>
                                <input type="submit" class="form-button w-button" value="Next ->">
                            </form>
                        </div>
                    </div>
                </div>

                
                <!-- Special Conditions -->
                <div class="question-container" v-if="questionId === 16">
                    <div class="question-div-2">
                        <div class="text-block-513">Do you have any of the following conditions?</div>
                        <div class="felix-form-block w-form">
                            <form @submit.prevent="checkResponseSelected('specialConditions')">
                                <label class="w-checkbox checkbox-field-15 w-clearfix" v-for="condition in specialConditions" :key="condition">
                                    <input type="checkbox" :value="condition" v-model="formData.specialConditions" class="w-checkbox-input checkbox-11">
                                    <span class="checkbox-label-12 w-form-label" for="checkbox-3">{{condition}}</span>
                                </label>
                                <input type="submit" class="form-button w-button" value="Next ->">
                            </form>
                        </div>
                    </div>
                </div>

                <!-- Additional Information -->
                <div class="question-container" v-if="questionId === 17">
                    <div class="question-div-2">
                        <div class="text-block-513">Is there anything else you want your doctor to know about your condition or health?</div>
                        <div class="felix-form-block w-form">
                            <form @submit.prevent="handleFinalSubmit">
                                <textarea v-model="formData.additionalInfo" class="text-field-43 w-input" placeholder="Share any additional information..." required></textarea>
                                <input type="submit" class="form-button w-button" value="Submit">
                            </form>
                        </div>
                    </div>
                </div>
            
        </div>
    </section>
</div>
</template>

<script>
export default {
    name: 'EDQuestionnaire',
    data() {
        return {
            baseUrl: process.env.VUE_APP_API_ENDPOINT,
            questionId: 2,
            totalQuestions: 17,
            showSideEffects:false,
            showCardRisk: false,
            askConditions:false,
            askDrugDetails:false,
            currentConditionIndex: 0,
            currentDrugIndex:0,
            formData: {
                firstName: '',
                lastName: '',
                dob: '',
                email: '',
                phone: '',
                address: '',
                city: '',
                state: '',
                zip: '',

                erectionProblem: '',
                erectionTiming: [],
                previousTreatment: null,
                treatmentDetails: '',
                hadSideEffects: null,
                sideEffectsDetails: '',

                physicalExam: null,
                physicalExamDetails: '',

                bloodPressureTaken: null,
                bloodPressureValue: '',

                takesMedications: null,
                medicationsList: '',
                nitrateMeds: [],

                hasAllergies: null,
                allergiesList: '',

                hasMedicalConditions: null,
                medicalConditionsList: '',

                cardioRisks: [],
                riskDetails: {},

                diagnoses: [],
                diagnosisDetails: {},

                cardioSymptoms: [],
                legCrampDetails: '',

                drugs: [],
                drugDetails: {},

                specialConditions: [],
                additionalInfo: ''
            },
            // Component options
            erectionProblemOptions: [
                'Yes - every time',
                'Yes - more than half the time',
                'Yes - on occasion',
                'Yes - but rarely',
                'I never have a problem getting or maintaining an erection'
            ],
            erectionTimingOptions: [
                'When you wake up',
                'Other times',
                'Neither'
            ],
            physicalExamOptions: [{
                    label: 'Yes, I am in good health',
                    value: 'Yes, I am in good health',
                    requiresDetails: false
                },
                {
                    label: 'Yes, but they found problems',
                    value: 'Yes, but they found problems',
                    requiresDetails: true
                },
                {
                    label: 'No',
                    value: 'No',
                    requiresDetails: false
                }
            ],
            nitrateOptions: [
                'Nitroglycerin spray, ointment, patches or tablets',
                'Isosorbide mononitrate or dinitrate',
                'Other medicines containing nitrates',
                'Alpha blocker medications',
                'Riociguat (Adempas)',
                'None apply'
            ],
            cardiovascularRisks: [{
                    label: 'Diabetes',
                    detailPrompt: 'Tell us more about your diabetes:',
                    placeholder: 'When was your last A1c and what was the value?'
                },
                {
                    label: 'High cholesterol',
                    detailPrompt: 'Tell us more about your high cholesterol:',
                    placeholder: 'Please provide details about your cholesterol...'
                },
                {
                    label: 'High blood pressure',
                    detailPrompt: 'Tell us more about your high blood pressure:',
                    placeholder: 'Please provide details about your blood pressure...'
                },
                {
                    label: 'Father had heart attack/disease at 55 or younger'
                },
                {
                    label: 'Mother had heart attack/disease at 65 or younger'
                },
                {
                    label: 'None apply'
                }
            ],
            medicalConditions: [
                'Prostate cancer',
                'Enlarged prostate (BPH)',
                'Kidney transplant or condition',
                'Liver disease',
                'Multiple Sclerosis',
                'Spinal injuries/paralysis',
                'Neurological diseases',
                'Stomach/intestinal ulcers',
                'Heart arrhythmias',
                'Heart abnormalities',
                'None of these apply'
            ],
            cardiovascularSymptoms: [{
                    label: 'Chest pain/shortness of breath climbing stairs'
                },
                {
                    label: 'Chest pain/shortness of breath during sexual activity'
                },
                {
                    label: 'Unexplained fainting or dizziness'
                },
                {
                    label: 'Prolonged cramping of the legs with exercise',
                    requiresDetails: true
                },
                {
                    label: 'Abnormal heart beats or rhythms'
                },
                {
                    label: 'None of these apply'
                }
            ],
            recreationalDrugs: [
                'Poppers or Rush',
                'Amyl Nitrate or Butyl Nitrate',
                'Cocaine',
                'Cigarettes',
                'Other',
                'No I don\'t use any of these'
            ],
            specialConditions: [
                'Curved/bent penis interfering with sex',
                'Pain with erections/ejaculation',
                'Tight foreskin',
                'None of these apply'
            ]
        }
    },
    computed: {
        selectedRisksWithDetails() {
            return this.cardiovascularRisks.filter(risk =>
                this.formData.cardioRisks.includes(risk.label) && risk.detailPrompt
            )
        },
        selectedDiagnoses() {
            return this.formData.diagnoses.filter(d => d !== 'None of these apply')
        },
        selectedDrugs() {
            return this.formData.drugs.filter(d => d !== 'No I don\'t use any of these')
        },
        needsLegCrampDetails() {
            return this.formData.cardioSymptoms.includes('Prolonged cramping of the legs with exercise')
        },
        filteredDiagnoses() {
            return this.formData.diagnoses.filter(d => d !== 'None of these apply');
        },
        currentCondition() {
            return this.filteredDiagnoses[this.currentConditionIndex];
        },
        currentDrug(){
            return this.selectedDrugs[this.currentDrugIndex];
        }
    },
    methods: {
        checkResponseSelected(field){
            if(this.formData[field].length  < 1){
                return;
            }else{
                this.nextQuestion();
            }
        },
        formatFormData() {
        
            const formattedData = {
                formObj: {
                    consentsSigned: true,
                    selfReportedMeds: this.formData.medicationsList,
                    allergies: this.formData.allergiesList || 'None',
                    medicalConditions: this.formatMedicalConditions(),

                    // Format Q&A pairs with full questions and available options
                    Q1: `Do you ever have a problem getting or maintaining an erection that is rigid enough for sex? Available Options: ${this.erectionProblemOptions.join(', ')}`,
                    A1: this.formData.erectionProblem,

                    Q2: `Do you get erections... Available Options: ${this.erectionTimingOptions.join(', ')}`,
                    A2: this.formData.erectionTiming,

                    Q3: "Have you ever been formally treated for ED or tried any medicines, vitamins, or supplements to treat it? Available Options: Yes, No",
                    A3: this.formData.previousTreatment,

                    Q4: "Please provide details about your previous ED treatments and any side effects experienced",
                    A4: this.formatTreatmentDetails(),

                    Q5: "Have you had a physical exam with a healthcare provider in the past 5 years? Available Options: Yes - I am in good health, Yes - but they found problems, No",
                    A5: this.formatPhysicalExam(),

                    Q6: "Was your blood pressure taken in the past year? Available Options: Yes, No",
                    A6: this.formatBloodPressure(),

                    Q7: "Do you take any medications, vitamins, or supplements regularly? Available Options: Yes, No",
                    A7: this.formData.medicationsList || "None",

                    Q8: `Do you take any of the following medicines? Available Options: ${this.nitrateOptions.join(', ')}`,
                    A8: this.formatArrayResponse(this.formData.nitrateMeds),

                    Q9: "Do you have any allergies? Available Options: Yes, No",
                    A9: this.formatAllergies(),

                    Q10: "Do you have any medical conditions or history of prior surgeries? Available Options: Yes, No",
                    A10: this.formatMedicalConditions(),

                    Q11: `Do any of the following cardiovascular risk factors apply to you? Available Options: ${this.cardiovascularRisks.map(risk => risk.label).join(', ')}`,
                    A11: this.formatCardioRisks(),

                    Q12: `Have you been diagnosed with any of the following conditions? Available Options: ${this.medicalConditions.join(', ')}`,
                    A12: this.formatDiagnoses(),

                    Q13: `Do you experience any of the following cardiovascular symptoms? Available Options: ${this.cardiovascularSymptoms.map(symptom => symptom.label).join(', ')}`,
                    A13: this.formatCardioSymptoms(),

                    Q14: `Do you use any of the following recreational drugs? Available Options: ${this.recreationalDrugs.join(', ')}`,
                    A14: this.formatDrugUse(),

                    Q15: `Do you have any of the following conditions? Available Options: ${this.specialConditions.join(', ')}`,
                    A15: this.formatArrayResponse(this.formData.specialConditions),

                    Q16: "Is there anything else you want your doctor to know about your condition or health?",
                    A16: this.formData.additionalInfo || "None"
                },
                pharmacyId: "",
                masterId: `visit_${Date.now()}`,
                company: "newSelf",
                visitType: "ed"
            }

            return formattedData
        },

        formatArrayResponse(arr) {
            console.log(arr)
            if (!arr || !arr.length) return 'None'
            return arr.join('; ')
        },

        formatTreatmentDetails() {
            if (this.formData.previousTreatment === 'No') return 'No previous treatment'
            let details = this.formData.treatmentDetails
            if (this.formData.hadSideEffects === 'Yes') {
                details += `\nSide effects: ${this.formData.sideEffectsDetails}`
            }
            return details
        },

        formatPhysicalExam() {
            if (!this.formData.physicalExam) return 'No recent physical exam'
            return this.formData.physicalExam.requiresDetails ?
                `${this.formData.physicalExam.label}: ${this.formData.physicalExamDetails}` :
                this.formData.physicalExam.label
        },

        formatBloodPressure() {
            return this.formData.bloodPressureTaken === 'Yes' ?
                `Yes - ${this.formData.bloodPressureValue}` :
                'No recent blood pressure check'
        },

        formatAllergies() {
            return this.formData.hasAllergies === 'Yes' ?
                this.formData.allergiesList :
                'No allergies'
        },

        formatMedicalConditions() {
            if (this.formData.hasMedicalConditions === 'No') return 'None'
            return this.formData.medicalConditionsList
        },

        formatCardioRisks() {
            if (!this.formData.cardioRisks.length) return 'None'
            return this.formData.cardioRisks.map(risk => {
                const details = this.formData.riskDetails[risk]
                return details ? `${risk}: ${details}` : risk
            }).join('; ')
        },

        formatDiagnoses() {
            if (!this.selectedDiagnoses.length) return 'None'
            return this.selectedDiagnoses.map(diagnosis => {
                const details = this.formData.diagnosisDetails[diagnosis]
                return details ? `${diagnosis}: ${details}` : diagnosis
            }).join('; ')
        },

        formatCardioSymptoms() {
            if (!this.formData.cardioSymptoms.length) return 'None'
            let symptoms = this.formData.cardioSymptoms
            if (this.needsLegCrampDetails) {
                symptoms = symptoms.map(s =>
                    s === 'Prolonged cramping of the legs with exercise' ?
                    `${s}: ${this.formData.legCrampDetails}` : s
                )
            }
            return symptoms.join('; ')
        },

        formatDrugUse() {
            if (!this.selectedDrugs.length) return 'None'
            return this.selectedDrugs.map(drug => {
                const details = this.formData.drugDetails[drug]
                return details ? `${drug}: ${details}` : drug
            }).join('; ')
        },

        async handleFinalSubmit() {
            try {
                const formattedData = this.formatFormData()
                const response = await this.$axios.post(`${this.baseUrl}/forms/assessment-form/ed_assesment/${this.$route.params.id}`, formattedData)
                if (response.data.status==='success') {
                    this.$router.push('/success');
                } else {
                    throw new Error('Form submission failed')
                }
            } catch (error) {
                console.error('Error submitting form:', error)
                alert('There was an error submitting your form. Please try again.')
            }
        },

        nextQuestion() {
            if (this.questionId < this.totalQuestions) {
                this.questionId++
                window.scrollTo(0, 0)
            }
        },

        checkCardHealth(){
            if(this.formData.cardioRisks.length  < 1){
                return;
            }

            let risk = ['Diabetes','High cholesterol','High blood pressure'];
            if (risk.some(r => this.formData.cardioRisks.includes(r))) {
                this.showCardRisk = true;
            }else{
                this.nextQuestion();
            }
        },
        setErections(option){
            this.formData.erectionTiming = option;
            this.nextQuestion();
        },
        handleErectionProblem(option) {
            this.formData.erectionProblem = option;
            this.nextQuestion();
        },

        handlePreviousTreatment(answer) {
            this.formData.previousTreatment = answer;
            if (answer === 'No') {
                this.questionId += 2; // Skip treatment details
            } else {
                this.nextQuestion();
            }
        },

        handleSideEffects(answer) {
            this.formData.hadSideEffects = answer;
            if (answer === 'No') {
                this.nextQuestion();
            }
        },

        handlePhysicalExam(option) {
            this.formData.physicalExam = option;
            if (!option.requiresDetails) {
                this.nextQuestion();
            }
        },

        handleBloodPressure(answer) {
            this.formData.bloodPressureTaken = answer;
            if (answer === 'No') {
                this.nextQuestion();
            }
        },

        handleMedications(answer) {
            this.formData.takesMedications = answer;
            if (answer === 'No') {
                this.nextQuestion();
            }
        },

        handleAllergies(answer) {
            this.formData.hasAllergies = answer;
            if (answer === 'No') {
                this.nextQuestion();
            }
        },

        handleMedicalConditions(answer) {
            this.formData.hasMedicalConditions = answer;
            if (answer === 'No') {
                this.nextQuestion();
            }
        },

        handleCardioRiskSubmit() {
            // Remove 'None apply' if other options are selected
            if (this.formData.cardioRisks.length > 1 &&
                this.formData.cardioRisks.includes('None apply')) {
                this.formData.cardioRisks = this.formData.cardioRisks.filter(risk =>
                    risk !== 'None apply'
                );
            }
            this.nextQuestion();
        },
        handleSingleConditionSubmit() {
        // Check if all selected conditions have details
            if (!this.formData.diagnosisDetails[this.currentCondition]?.trim()) {
                return;
            }

            // Move to the next condition if available, otherwise go to the next question
            if (this.currentConditionIndex < this.filteredDiagnoses.length - 1) {
                this.currentConditionIndex++;
            } else {
                this.nextQuestion();
            }
        },
        handleSingleDrugSubmit() {
        // Check if all selected conditions have details
            if (!this.formData.drugDetails[this.currentDrug]?.trim()) {
                return;
            }

            // Move to the next condition if available, otherwise go to the next question
            if (this.currentDrugIndex < this.selectedDrugs.length - 1) {
                this.currentDrugIndex++;
            } else {
                this.nextQuestion();
            }
        },
        handleDiagnosesSubmit() {
            // Remove 'None of these apply' if other options are selected
            if(this.formData.diagnoses.length  < 1){
                return;
            }

            if (
                this.formData.diagnoses.length > 1 &&
                this.formData.diagnoses.includes('None of these apply')
            ) {
                this.formData.diagnoses = this.formData.diagnoses.filter(
                    diagnosis => diagnosis !== 'None of these apply'
                );
            }

            // Check if only 'None of these apply' is selected; if not, do not proceed
            if (
                this.formData.diagnoses.length === 1 &&
                this.formData.diagnoses[0] === 'None of these apply'
            ) {
                this.nextQuestion();
            } else {
                this.askConditions=true;
            }
        },


        handleCardioSymptomsSubmit() {
            if(this.formData.cardioSymptoms.length  < 1){
                return;
            }

            // Remove 'None of these apply' if other options are selected
            if (this.formData.cardioSymptoms.length > 1 &&
                this.formData.cardioSymptoms.includes('None of these apply')) {
                this.formData.cardioSymptoms = this.formData.cardioSymptoms.filter(symptom =>
                    symptom !== 'None of these apply'
                );
            }

            // If leg cramps not selected, clear details
            if (!this.needsLegCrampDetails) {
                this.formData.legCrampDetails = '';
            }

            this.nextQuestion();
        },

        handleDrugsSubmit() {
            if(this.formData.drugs.length  < 1){
                return;
            }
            // Remove 'No I don't use any of these' if other options are selected
            if (this.formData.drugs.length > 1 &&
                this.formData.drugs.includes('No I don\'t use any of these')) {
                this.formData.drugs = this.formData.drugs.filter(drug =>
                    drug !== 'No I don\'t use any of these'
                );
            }

            if (
                this.formData.drugs.length === 1 &&
                this.formData.drugs[0] === 'No I don\'t use any of these'
            ) {
                this.nextQuestion();
            } else {
                this.askDrugDetails=true;
            }
        },
    },
    created(){
        console.log(`here in ed ${this.baseUrl}`)
    }
}
</script>

<style scoped>
/* Previous styles remain the same */

.form-row {
    display: flex;
    gap: 15px;
    margin-bottom: 15px;
}

.form-row input,
.form-row select {
    flex: 1;
}

.form-subs {
    font-size: 14px;
    color: #666;
    margin-bottom: 15px;
}

/* Rest of the styles remain the same */
</style>
